
<template>
  <div class="comments-section">
    <div class="section-header">
      <h3>评论区 <span class="count">({{total}})</span></h3>
    </div>

    <!-- 评论列表 -->
    <div class="comments-list"
         v-infinite-scroll="loadMore"
         infinite-scroll-disabled="loading"
         infinite-scroll-distance="10"
         infinite-scroll-immediate="false"
    >
      <div class="comment-item" v-for="comment in comments" :key="comment.id">
        <div class="comment-main">
          <div class="comment-header">
            <div class="comment-user-info">
              <el-avatar :src="comment.userAvatar" :size="40"></el-avatar>
              <div class="user-meta">
                <span class="username">{{comment.userName}}</span>
                <span class="time">{{comment.createTime}}</span>
              </div>
            </div>
          </div>
          <div class="comment-content">
            <div class="text">{{comment.content}}</div>
            <!-- 评论图片 -->
            <div class="image-list" v-if="comment.images">
              <el-image
                  v-for="(img, imgIndex) in formatImages(comment.images)"
                  :key="imgIndex"
                  :src="img"
                  fit="cover"
                  :preview-src-list="formatImages(comment.images)"
              ></el-image>
            </div>
            <!-- 评论操作 -->
            <div class="comment-actions">
                  <span class="action-btn" @click="handleReply(comment)">
                    <i class="el-icon-chat-dot-round"></i> 回复
                  </span>
              <span class="action-btn delete"
                    v-if="comment.createBy === userStore.userInfo.id || formLabelAlign.createBy === userStore.userInfo.id"
                    @click="deleteComment(comment.id)">
                    <i class="el-icon-delete"></i> 删除
                  </span>
            </div>
          </div>
        </div>

        <!-- 回复列表 -->
        <div class="replies-list" v-if="comment.replies && comment.replies.length">
          <div class="reply-item" v-for="reply in comment.replies" :key="reply.id">
            <div class="comment-header">
              <div class="comment-user-info">
                <el-avatar :src="reply.userAvatar" :size="32"></el-avatar>
                <div class="user-meta">
                  <span class="username">{{reply.userName}}</span>
                  <span class="reply-to" v-if="reply.replyToUserName">
                        回复 <span class="reply-name">@{{reply.replyToUserName}}</span>
                      </span>
                  <span class="time">{{reply.createTime}}</span>
                </div>
              </div>
            </div>
            <div class="reply-content">
              <div class="text">{{reply.content}}</div>
              <!-- 回复图片 -->
              <div class="image-list" v-if="reply.images">
                <el-image
                    v-for="(img, imgIndex) in formatImages(reply.images)"
                    :key="imgIndex"
                    :src="img"
                    fit="cover"
                    :preview-src-list="formatImages(reply.images)"
                ></el-image>
              </div>
              <!-- 回复操作 -->
              <div class="reply-actions">
                    <span class="action-btn" @click="handleReply(comment, reply)">
                      <i class="el-icon-chat-dot-round"></i> 回复
                    </span>
                <span class="action-btn delete"
                      v-if="reply.createBy === userStore.userInfo.id || formLabelAlign.createBy === userStore.userInfo.id"
                      @click="deleteComment(reply.id)">
                      <i class="el-icon-delete"></i> 删除
                    </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div class="load-more" v-if="loading">
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-if="comments.length === 0 && !loading">
        暂无评论，快来抢沙发吧~
      </div>
    </div>
    <!-- 图片预览 -->
    <div class="image-preview" v-if="commentImages.length">
      <div class="preview-item" v-for="(img, index) in commentImages" :key="index">
        <el-image :src="img" fit="cover"></el-image>
        <div class="delete-btn" @click="deleteCommentImage(index)">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
    <!-- 评论输入框 -->
    <div class="comment-input" :class="{ 'reply-mode': replyTo }">
      <div class="input-wrapper">
        <div class="reply-info" v-if="replyTo">
          <span>回复 {{replyTo.userName}}</span>
          <i class="el-icon-close" @click="cancelReply"></i>
        </div>
        <el-input
            type="textarea"
            v-model="commentText"
            class="comment-textarea"
            :rows="3"
            :placeholder="replyTo ? `回复 ${replyTo.userName}...` : '说点什么...'"
            maxlength="200"
            show-word-limit
        ></el-input>

        <!-- 图片上传 -->
        <div class="action-bar">
          <el-upload
              :action="action"
              :show-file-list="false"
              :on-success="onUploadSuccess"
              :before-upload="beforeUpload"
              accept="image/*"
              multiple
          >
            <i class="el-icon-picture"></i>
          </el-upload>
          <el-button
              type="primary"
              size="small"
              @click="submitComment"
              :disabled="!commentText.trim() && !commentImages.length"
          >发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 评论组件
 */
export default {
  name: "comments-section",
  props: {
    // 评论所属内容ID
    targetId: {
      type: [String, Number],
      required: true
    },
    // 评论类型(circle/faka等)
    busType: {
      type: String,
      required: false
    },
    //评论所属用户id
    targetUserId: {
      type: Number,
      required: true
    }
  },
  data(){
    return{
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      comments: [],
      commentText: '',
      commentImages: [],
      replyTo: null,
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      finished: false,
      maxImages: 9 // 最大图片数量限制
    }
  },
  computed: {
    hasLogin(){
      return this.userStore?.userInfo.id ||sessionStorage.getItem("accessToken")||localStorage.getItem("accessToken")
    }
  },
  mounted() {
    if(this.hasLogin)
    this.userStore.loadUser()
    this.loadComments();
    },
  methods:{
    // 格式化图片数组
    formatImages(images) {
      if (!images) return []
      return typeof images === 'string' ? images.split(',') : images
    },

    // 加载更多
    loadMore() {
      if (this.loading || this.finished) return
      this.loadComments()
    },

    // 加载评论列表
    async loadComments(refresh = false) {
      if (refresh) {
        this.page = 1
        this.comments = []
        this.finished = false
      }

      if (this.loading || this.finished) return
      this.loading = true

      try {
        const res = await this.$http2({
          url: `/klgeek/comment/list/${this.targetId}`,
          method: 'get',
          params: {
            pageNum: this.page,
            pageSize: this.pageSize,
            busType:this.busType
          }
        })

        const { rows, total } = res
        this.total = total

        if (refresh) {
          this.comments = rows
        } else {
          this.comments = [...this.comments, ...rows]
        }

        // 判断是否加载完所有数据
        this.finished = this.comments.length >= total
        this.page++

      } catch (error) {
        console.error('获取评论失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 提交评论
    async submitComment() {
      if (!this.hasLogin) {
        window.$showLogin()
        return
      }
      if (!this.commentText.trim() && !this.commentImages.length) {
        this.$message.warning('请输入评论内容或上传图片')
        return
      }
      try {
        const params = {
          creationId: this.targetId,
          content: this.commentText,
          images: this.commentImages.join(","),
          userName: this.userStore.userInfo.nickName,
          userAvatar: this.userStore.userInfo.headImageThumb,
          createBy:this.targetUserId,
          busType:this.busType
        }

        if (this.replyTo) {
          params.parentId = this.replyTo.commentId
          params.replyUserId = this.replyTo.userId
          params.replyToUserName = this.replyTo.replyToUserName
        }
        console.log(params)
        await this.$http2({
          url: '/klgeek/comment',
          method: 'post',
          data: params
        })

        this.$message.success('评论成功')
        this.commentText = ''
        this.commentImages = []
        this.cancelReply()
        this.loadComments(true) // 刷新评论列表
      } catch (error) {
        this.$message.error(error)
      }
    },

    // 上传成功回调
    onUploadSuccess(response, file) {
      if (response.code === 200) {
        // 检查图片数量限制
        if (this.commentImages.length >= this.maxImages) {
          this.$message.warning(`最多只能上传${this.maxImages}张图片`)
          return
        }

        // 添加图片URL到数组
        this.commentImages.push(response.data.thumbUrl)
      } else {
        this.$message.error('图片上传失败')
      }
    },

    // 删除评论图片
    deleteCommentImage(index) {
      this.commentImages.splice(index, 1)
    },

    // 上传前检查
    beforeUpload(file) {
      // 检查图片数量
      if (this.commentImages.length >= this.maxImages) {
        this.$message.warning(`最多只能上传${this.maxImages}张图片`)
        return false
      }

      // 检查文件类型
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }

      // 检查文件大小（这里限制为5MB）
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB')
        return false
      }
      return true
    },

    // 处理回复
    handleReply(comment, reply = null) {
      if (!this.hasLogin) {
        window.$showLogin()
        return
      }

      this.replyTo = {
        commentId: reply ? comment.id : comment.id,
        userId: reply ? reply.createBy : comment.createBy,
        userName: reply ? reply.userName : comment.userName,
        replyToUserName: reply?.userName
      }

      // 聚焦到评论输入框
      this.$nextTick(() => {
        const textarea = this.$el.querySelector('.el-textarea__inner')
        console.log(textarea)
        if (textarea) {
          textarea.focus()
        }
      })
    },

    // 取消回复
    cancelReply() {
      this.replyTo = null
      this.commentText = ''
    },

    // 删除评论
    async deleteComment(commentId) {
      try {
        await this.$confirm('确定要删除这条评论吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        await this.$http2({
          url: `/klgeek/comment/${commentId}`,
          method: 'delete'
        })

        this.$message.success('删除成功')
        // 刷新评论列表
        this.loadComments(true)

      } catch (error) {
        if (error !== 'cancel') { // 忽略取消操作的报错
          this.$message.error('删除失败')
          console.error('删除评论失败:', error)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.comments-section {
  margin-top: 20px;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h3 {
      font-size: 16px;
      margin: 0;
      color: #333;
    }

    .view-all {
      font-size: 13px;
      color: #666;
      text-decoration: none;

      &:hover {
        color: #409EFF;
      }
    }
  }

  .comments-list {
  }

  .image-preview {
    .preview-item {
      position: relative;
      display: inline-block;
      margin: 5px;

      .el-image {
        width: 100px;
        height: 100px;
        border-radius: 4px;
      }

      .delete-btn {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
        color: #999;

        &:hover {
          color: #409EFF;
        }
      }
    }
  }

  .comment-input {
    margin-top: 20px;
    padding: 10px;
    background: #f5f5f5;
    border-radius: 4px;

    &.reply-mode {
      padding: 10px;
    }

    .input-wrapper {
      display: flex;
      align-items: center;

      .reply-info {
        margin-right: 10px;
        color: #999;

        i {
          cursor: pointer;
          margin-left: 5px;

          &:hover {
            color: #409EFF;
          }
        }
      }

      .comment-textarea {
        flex: 1;
      }

      .action-bar {
        margin-left: 10px;

        .el-upload {
          margin-right: 10px;
        }
      }
    }
  }
}
.comment-item {
  margin-bottom: 24px;

  .comment-main {
    margin-bottom: 20px;

    .comment-header {
      margin-bottom: 12px;

      .comment-user-info {
        display: flex;
        align-items: center;
        gap: 12px;

        .user-meta {
          display: flex;
          align-items: center;
          gap: 12px;

          .username {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            line-height: 1;
          }

          .time {
            font-size: 12px;
            color: #999;
            line-height: 1;
          }
        }
      }
    }

    .comment-content {
      padding-left: 52px; // 头像宽度(40px) + 间距(12px)

      .text {
        font-size: 14px;
        color: #333;
        line-height: 1.6;
      }
    }
  }

  // 回复列表样式
  .replies-list {
    margin-top: 16px;
    margin-left: 52px; // 与主评论内容对齐
    padding-left: 16px; // 添加左侧内边距
    border-left: 2px solid #f0f0f0; // 添加左侧边框线

    .reply-item {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .comment-header {
        margin-bottom: 8px;

        .comment-user-info {
          display: flex;
          align-items: center;
          gap: 8px;

          .user-meta {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;

            .username {
              font-size: 14px;
              font-weight: 500;
              color: #333;
            }

            .reply-to {
              font-size: 14px;
              color: #666;

              .reply-name {
                color: #409EFF;
              }
            }

            .time {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }

      .reply-content {
        padding-left: 40px; // 头像宽度(32px) + 间距(8px)

        .text {
          font-size: 14px;
          color: #333;
          line-height: 1.6;
        }
      }
    }
  }
}

.comment-actions,
.reply-actions {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 16px;

  .action-btn {
    display: inline-flex;
    align-items: center;
    font-size: 13px;
    color: #8c8c8c;
    cursor: pointer;
    padding: 4px 0;

    i {
      margin-right: 4px;
      font-size: 14px;
    }

    &:hover {
      color: #409EFF;
    }

    &.delete {
      &:hover {
        color: #F56C6C;
      }
    }
  }
}

// 回复列表中的操作按钮稍微小一点
.reply-actions {
  .action-btn {
    font-size: 12px;

    i {
      font-size: 13px;
    }
  }
}

.comment-input {
  background: #fff;
  padding: 20px;
  border-top: 1px solid #f5f5f5;

  &.reply-mode {
    padding-top: 10px;
  }

  .input-wrapper {
    .reply-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 0;
      color: #666;
      font-size: 13px;

      i {
        cursor: pointer;
        &:hover {
          color: #409EFF;
        }
      }
    }
  }
}

// 评论图片列表样式
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;

  .el-image {
    width: 100px;
    height: 100px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}

// 回复列表中的图片稍微小一点
.replies-list {
  .image-list {
    .el-image {
      width: 80px;
      height: 80px;
    }
  }
}
</style>